
export class SearchCriteria {
    constructor(companyName: string, pageSize: number) {
        this.CompanyName = companyName;
        this.PageSize = pageSize;
    }

    public CompanyName: string;
    public PageSize: number;
    public PageNumber: number;
}
